import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useParams } from 'react-router';
import { TokenContext } from '../Context/TokenContext';
import LegalPageEditor from '../Componant/LegalPageEditor';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

export default function CGUEditPage() {
    const { clientId } = useParams();
    const { accessToken } = useContext(TokenContext);
    const [appName, setAppName] = useState(clientId);

    useEffect(() => {
        if (!accessToken || !clientId) return;
        axios.get(`${API_URL}/api/applications/${clientId}`, { headers: { Authorization: `Bearer ${accessToken}` } })
            .then((res) => setAppName(res.data?.name || clientId))
            .catch(() => setAppName(clientId));
    }, [accessToken, clientId]);

    return (
        <LegalPageEditor
            settingKey={`terms_of_use:${clientId}`}
            heading={`CGU — ${appName}`}
            description={`Affiché sur /cgu/${clientId} et sur la fiche du logiciel. Règles d'usage du site/compte, propriété intellectuelle, responsabilités, données personnelles...`}
            backTo="/settings/cgu"
            backLabel="Retour à la liste des logiciels"
        />
    );
}
